import { render, staticRenderFns } from "./DynamicButtonContainers.vue?vue&type=template&id=0a52bdee"
import script from "./DynamicButtonContainers.vue?vue&type=script&lang=js"
export * from "./DynamicButtonContainers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports